import React from 'react';
import { Button, Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import {
  getSupplierOrderDisplayNumber,
  type SupplierOrderDto,
} from '../../../dto/supplierOrder';
import { getSupplierOrderStatusColor } from '../supplierOrderStatuses';
import './SupplierOrderSummaryPreview.css';

const EMPTY_VALUE = '-';

interface SupplierOrderSummaryPreviewProps {
  order: SupplierOrderDto;
  onOrderClick: () => void;
}

const SupplierOrderSummaryPreview: React.FC<SupplierOrderSummaryPreviewProps> = ({
  order,
  onOrderClick,
}) => {
  const { t } = useTranslation(['orders']);

  return (
    <div className="supplier-order-summary-preview">
      <span className="supplier-order-summary-preview__supplier">
        {order.supplier?.name || EMPTY_VALUE}
      </span>
      <div className="supplier-order-summary-preview__meta">
        <Button
          className="supplier-order-summary-preview__link"
          type="link"
          onClick={onOrderClick}
        >
          {getSupplierOrderDisplayNumber(order)}
        </Button>
        <Tag
          color={getSupplierOrderStatusColor(order.status)}
          className="supplier-order-summary-preview__status"
        >
          {t(`orders:supplierOrders.status.${order.status}`)}
        </Tag>
      </div>
    </div>
  );
};

export default SupplierOrderSummaryPreview;
